namespace Matrix.Workflow {
    export interface ClientFunctionGetModelRequest extends Serenity.ServiceRequest {
        TriggerCode?: string;
        FunctionName?: string;
    }
}
